import React, {useEffect, useState} from 'react';
import {Button, Container, FormControl, FormLabel, Input} from "@chakra-ui/react";
import Logo from "../../utilities/Logo";
import {Box, Flex, Text} from "@chakra-ui/layout";
import Swal from "sweetalert2";
import {StateType, useStudentAuthDispatch} from "../../../store/store";
import {adminLogin} from "../../../action/adminAction";
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

function AdminLogin() {
  const dispatch = useStudentAuthDispatch();
  const adminState = useSelector((state: StateType) => state.rootReducer.adminReducer);
  let history = useHistory();
  const [adminUsername, setAdminUsername] = useState<string>("");
  const [adminPassword, setAdminPassword] = useState<string>("");

  async function submitForm(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (adminUsername === "") {
      return Swal.fire({
        icon: "error",
        text: "your email is blank, fill it in"
      })
    }
    if (adminPassword === "") {
      return Swal.fire({
        icon: "error",
        text: "your password is blank, fill it in"
      })
    }
    console.log("submitted")
    await dispatch(adminLogin({username: adminUsername, password: adminPassword}))
  }

  useEffect(() => {
    if (adminState.data.role === "admin") {
      history.push("/admin")
    }
  }, [adminState.data.role])

  return (
    <Flex justifyContent={"center"} alignItems={"center"} h={"80vh"}>
      <Container>
        <Box pos={"relative"}>
          <Text textTransform={"capitalize"} color={"brand.darkGreen"} pos={"absolute"} right={"25%"} fontSize={"xs"}
                fontWeight={"extrabold"}>admin</Text>
          <Logo _fontSize={"6xl"} _mt={0}/>
        </Box>
        <Flex flexDirection={"column"} mt={12}>
          <form onSubmit={(e) => submitForm(e)}>
            <FormControl>
              <FormLabel htmlFor="admin-username" textTransform={"capitalize"} fontWeight={"bold"} fontSize={"md"}>email
                address</FormLabel>
              <Input type={"text"} id="admin-email" value={adminUsername} onChange={(e) => setAdminUsername(e.target.value)}
                     required placeholder="Enter your username"/>
            </FormControl>
            <br/>
            <FormControl>
              <FormLabel htmlFor="admin-password" textTransform={"capitalize"} fontWeight={"bold"}
                         fontSize={"md"}>password</FormLabel>
              <Input type={"password"} id="admin-password" value={adminPassword}
                     onChange={(e) => setAdminPassword(e.target.value)} required placeholder="Enter your password"/>
            </FormControl>
            <br/>
            <Button type={"submit"} display={"block"} width={"100%"} bgColor={"brand.darkGreen"} color={"white"}
                    textTransform={"capitalize"} size={"lg"} fontSize={"md"}>login</Button>
          </form>
        </Flex>
      </Container>
    </Flex>

  );
}

export default AdminLogin;